import { render, staticRenderFns } from "./HandoverTakeback.vue?vue&type=template&id=55389efa&scoped=true&"
import script from "./HandoverTakeback.vue?vue&type=script&lang=js&"
export * from "./HandoverTakeback.vue?vue&type=script&lang=js&"
import style0 from "./HandoverTakeback.vue?vue&type=style&index=0&id=55389efa&lang=scss&scoped=true&"
import style1 from "./HandoverTakeback.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55389efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55389efa')) {
      api.createRecord('55389efa', component.options)
    } else {
      api.reload('55389efa', component.options)
    }
    module.hot.accept("./HandoverTakeback.vue?vue&type=template&id=55389efa&scoped=true&", function () {
      api.rerender('55389efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/hotb/HandoverTakeback.vue"
export default component.exports